import { Injectable } from '@angular/core';
import { DroplistItem, PageTabsLayoutPageService } from '@eforall/dashboard';


/**
 * The list of tabs on this page
 */
export enum ConfigurationAcceleratorsPageTabId {
	Accelerator = 1,
	Tab1 = 2,
	Tab2 = 3,
}

/**
 * The list if main tab droplist views on this page
 */
export enum ConfigurationAcceleratorsPageViewId {
	ProgramFacilitators = 1,
	Accelerators = 2,
}


@Injectable({ providedIn: 'root' })
export class ConfigurationAcceleratorsService extends PageTabsLayoutPageService<ConfigurationAcceleratorsPageTabId, ConfigurationAcceleratorsPageViewId> {
	private static readonly _viewDroplistItems: DroplistItem<never, ConfigurationAcceleratorsPageViewId>[] = [
		{
			uniqueId: ConfigurationAcceleratorsPageViewId.ProgramFacilitators,
			iconContext: {
				iconClass: 'fa-grip-horizontal',
				iconStyle: 'fa-solid',
				text: 'Program Facilitators',
				hideText: 'never',
			},
			customSort: '1-Accelerators-1'
		},
		{
			uniqueId: ConfigurationAcceleratorsPageViewId.Accelerators,
			iconContext: {
				iconClass: 'fa-grid',
				iconStyle: 'fa-solid',
				text: 'Accelerators',
				hideText: 'never',
			},
			customSort: '1-Accelerators-3'
		},

	];
	constructor() {
		super(ConfigurationAcceleratorsService._viewDroplistItems, ConfigurationAcceleratorsService.name, ConfigurationAcceleratorsPageTabId.Accelerator, ConfigurationAcceleratorsPageViewId.ProgramFacilitators);
	}

	public get viewId() {
		return ConfigurationAcceleratorsPageViewId;
	}

}